import { MouseEventHandler, useMemo, useRef } from 'react'

import { useLatest } from 'ahooks'
import { Button, ConfigProvider, ThemeConfig } from 'antd'
import { useTheme } from 'antd-style'

import { useSelfLoading } from '../../../hooks/useSelfLoading'

import { ThrottleButtonProps } from './interface'

/**
 * 带节流功能的 button，防止多次点击
 */
export const ThrottleButton = (props: ThrottleButtonProps) => {
  const {
    throttleTime = 1000,
    warning,
    danger,
    loading,
    onClick: externalOnClick,
    ...buttonProps
  } = props
  const throttleTimeRef = useLatest(throttleTime)
  const disabledRef = useRef(false)

  const handleButtonClick: MouseEventHandler<HTMLElement> = e => {
    if (disabledRef.current) {
      e.preventDefault()
      e.stopPropagation()
      return
    }
    disabledRef.current = true
    window.setTimeout(() => {
      disabledRef.current = false
    }, throttleTimeRef.current)
    externalOnClick?.(e)
  }

  const { loading: selfLoading, onClick } = useSelfLoading({
    loading,
    onClick: handleButtonClick
  })

  const btnNode = (
    <Button
      {...buttonProps}
      danger={danger || warning}
      loading={selfLoading}
      onClick={onClick}
    />
  )

  const theme = useTheme()
  const customTheme = useMemo(
    () =>
      ({
        token: {
          colorErrorBg: theme['orange-1'],
          colorErrorBgHover: theme['orange-2'],
          colorErrorBgActive: theme['orange-3'],
          colorErrorBorder: theme['orange-3'],
          colorErrorBorderHover: theme['orange-4'],
          colorErrorHover: theme['orange-5'],
          colorError: theme['orange-6'],
          colorErrorActive: theme['orange-7'],
          colorErrorTextHover: theme['orange-8'],
          colorErrorText: theme['orange-9'],
          colorErrorTextActive: theme['orange-10']
        }
      }) as ThemeConfig,
    [theme]
  )

  return warning ? (
    <ConfigProvider theme={customTheme}>{btnNode}</ConfigProvider>
  ) : (
    btnNode
  )
}
